<template>
  <div className="relative flex w-full h-fit text-[16px] font-medium text-left bg-white rounded-md">
    <span
      ref="selectedAppContainer"
      className="cursor-pointer text-xl font-umanforge p-2 mt-1.5 text-left"
      @click=" () => { isPopupVisible = !isPopupVisible } "
    >
      {{ t( `${ selectedApp.appKey }` ) }}
    </span>
    <span
      v-if="isPopupVisible"
      className="absolute overflow-hidden whitespace-nowrap flex flex-col gap-2 dark:bg-dark-bg-light absolute appear-jump bottom-[60px] left-0 bg-white shadow-2xl drop-shadow-lg p-2 rounded-lg transition-all duration-300"
      ref="appsListContainer"
    >
      <AppLink
        v-for="app in apps.filter( item => { return item != selectedApp } )"
        :key="app"
        :appName="t( `${ app.appKey }` )"
        :url="app.url"
        :icon="app.icon"
        :disable="store.getConnectedUser.allowApps == null || !store.getConnectedUser.allowApps.includes( app.appKey.toUpperCase() )"
      />
    </span>
  </div>
</template>

<script setup>
  import { useI18n } from 'vue-i18n';
  import { ref, watch } from 'vue';
  import AppLink from '@/components/footer/AppLink.vue';
  import { useStore } from '@/store/store';

  const store = useStore();
  const { t } = useI18n();


  defineProps( {
    apps: { Array, required: true },
    selectedApp: { Object, required: true }
  } );

  const isPopupVisible = ref( false );
  const selectedAppContainer = ref();
  const appsListContainer = ref();

  watch( isPopupVisible, ( value ) => {
    if ( value ) {
      document.addEventListener( 'click', handleClickOutside );
    } else {
      document.removeEventListener( 'click', handleClickOutside );
    }
  } );

  const handleClickOutside = ( event ) => {
    if ( event.target != selectedAppContainer.value && event.target != appsListContainer.value && ![ ...appsListContainer.value.children ].some( ( child ) => { return child === event.target; } ) ) {
      isPopupVisible.value = false;
    }
  };

</script>